/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/home",
    name: "Dashboard",
    slug: "home",
    icon: "ClipboardIcon",
  },
  {
    url: "/apps",
    name: "Apps",
    slug: "page2",
    icon: "GridIcon",
  },
  //   {
  //     url: "/mahasiswa/profil",
  //     name: "Profile",
  //     slug: "profile",
  //     icon: "UserIcon",
  //   },
];
